<template>
  <div class="page-container">
    <div class="query-title">材料计划汇总单</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="材料计划清单"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange1"
          @confirm="params => tableConfigConfirm(params, 'xTable')"
        >
          <template #button>
            <table-button :class="btn.className" v-for="btn in gridOptions.buttons" :key="btn.label" :name="btn.icon" :tip="btn.label" @click="tableEvent(btn)" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="params => rowClassName(params, 'xTable')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable')"
          />
        </Table-filter>

        <Table-filter title="汇总材料单" :show-custome="false">
          <template #button>
            <table-button v-for="btn in gridOptions2.buttons" :key="btn.label" :name="btn.icon" :tip="btn.label" @click="tableEventSum(btn)" />
          </template>
          <vxe-grid
            ref="xTable2"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
          >
            <template #remark="{row}">
              <el-input v-model="row.remark" size="mini" placeholder="请输入" />
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
  </div>
</template>

<script>
import { apiMaterialPlanSumList, apiMaterialPlanSumSave, apiMaterialPackageHandle, apiMaterialPlanSum } from '@/api/sap/material-plan'
import tableMixins from '@/utils/tableMixins'
import { pageSearch, config1, config2 } from './config/materialSumOrder'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox', width: 50 }],
        data: [],
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'export',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '汇总',
            style: 'primary',
            icon: 'sum',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'sum',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '包材确认',
            style: 'primary',
            icon: 'confirm',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'confirm',
            enabledCustom: 'N',
            dialog: '',
            className: 'leftSpacing',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '取消确认',
            style: 'primary',
            icon: 'cancle',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'cancel',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ]
      },
      gridOptions2: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox', width: 50 }],
        data: [],
        buttons: [
          {
            label: '导出',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'exportSumList',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '删除',
            style: 'primary',
            icon: 'delete',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'del',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '确认汇总',
            style: 'primary',
            icon: 'sum',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'confirm',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
        ]
      },
      already: [],
      pageSearch,
      searchField: {}
    }
  },
  created() {
    this.searchField = this.pageSearch
    this.initPage(config1, 'gridOptions')
    this.initPage(config2, 'gridOptions2', false)
  },
  methods: {
    initPage(pageConfig, name = 'gridOptions', flag = true) {
      const columns = []
      // const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const defaultFmt = { t: 's' }
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120,
          filters: [],
          filterMultiple: false,
          xlsxFmt: Object.assign(defaultFmt, pageConfig[key].xlsxFmt || {})
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        if (!flag) {
          delete obj.filters
          delete obj.filterMultiple
        }
        columns.push(obj)
      })
      this[name].columns = this[name].columns.concat(columns)
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { list, total, calculation, field } = await apiMaterialPlanSumList(params)
        if (list.length === 0 && total - 0) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(list)
        } else {
          this.gridOptions.data = list.concat(this.tableCountData)
        }
        this.gridOptions2.data = []
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    tableEvent(btn) {
      switch (btn.code) {
        case 'sum':
          this.handleSumList()
          break
        case 'confirm':
          this.handleConfirmList(1)
          break
        case 'cancel':
          this.handleConfirmList(0)
          break
        case 'export':
          this.exportExcel('nosum')
          break
      }
    },
    // 清单汇总
    async handleSumList() {
      const checkedData = this.$refs.xTable.getCheckboxRecords()

      if (!checkedData.length) return this.$message.warning('请选择需要汇总的数据！')

      // 过滤未汇总的数据
      const noSumCode = checkedData.filter(v => !v.packsum_id && v.status !== '已汇总')

      if (checkedData?.length && checkedData.length !== noSumCode.length) {
        return this.$message.success('请选择未汇总数据！')
      }

      // 有数据 进行汇总
      if (noSumCode.length) {
        this.PlanSum(noSumCode)
      } else if (!noSumCode.length && checkedData.length) {
        this.$message.warning('请选择未汇总数据！')
      }
    },
    async PlanSum(list) {
      // 请求接口
      const { sumitm: sumitem, msgtype } = await apiMaterialPackageHandle({ iv_mode: 'SEND', select: list, mplist: this.gridOptions.data, sumitm: this.gridOptions2.data })
      if (msgtype === 'E') return
      // 计划状态改变
      list.map(item => {
        item.status = '已汇总'
      })
      // 保存已经汇总的 _X_ID
      this.already = this.already.concat(list.map(v => v._X_ID))

      // 合并相同产品的计划
      const sumList = [...sumitem]
      this.gridOptions2.data = sumList.reduce((pre, cur, i) => {
        delete cur._X_ID
        cur.status = '未确认'
        // if (i === 0) {
          pre.push(cur)
          return pre
        // }
        // const item = pre.find(v => v.product_id === cur.product_id)
        // if (item) {
        //   item.planqty_box = (item.planqty_box - 0) + (cur.planqty_box - 0)
        //   item.planqty_bottle = (item.planqty_bottle - 0) + (cur.planqty_bottle - 0)
        //   item.planqty_ton = (item.planqty_ton - 0) + (cur.planqty_ton - 0)
        //   return pre
        // } else {
        //   pre.push(cur)
        //   return pre
        // }
      }, [])
    },
    // 清单包材确认
    async handleConfirmList(status) {
      const checkedData = this.$refs.xTable.getCheckboxRecords()
      const params = {
        iv_mode: status ? 'SUBMIT' : 'DELETE',
        mplist: this.gridOptions.data,
        select: checkedData
      }
      const res = await apiMaterialPackageHandle(params)
      if (res.msgtype === 'S') {
        checkedData.forEach(v => {
          v.status = status ? '已确认' : '未汇总'
        })
      } else {
        this.$message.warning(res.message)
      }
    },
    tableEventSum(btn) {
      switch (btn.code) {
        case 'del':
          this.PlanSumDetailDelete()
          break
        case 'confirm':
          this.handleConfirmSumOrder()
          break
        case 'exportSumList':
          this.exportExcel('sum')
          break
      }
    },
    async exportExcel(type) {
      if (type === 'sum') {
        frontExport(this.gridOptions2.columns, this.gridOptions2.data, '材料汇总单')
      } else {
        const params = {
          user_bp: this.$store.getters.role.USER_BP,
          ...this.allConditions
        }
        const data = await concurrencyReq(this.pagination.totalCount, params, apiMaterialPlanSumList, 'list')
        frontExport(this.gridOptions.columns, data, '材料计划清单')
      }
    },
    // 删除已经汇总
    PlanSumDetailDelete() {
      const checkedList = this.$refs.xTable2.getCheckboxRecords()
      const productIds = checkedList.map(v => v.product_id)

      // 删除汇总的明细
      checkedList.forEach(item => {
        const index = this.gridOptions2.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.data.splice(index, 1)
      })

      // 改变生产计划的状态为 未汇总
      this.gridOptions.data.map(item => {
        if (productIds.includes(item.product_id) && item.status === '已汇总') {
          item.status = '未汇总'
          const index = this.already.findIndex(v => v._X_ID === item._X_ID)
          this.already.splice(index, 1)
        }
      })
    },
    // 确认汇总材料单
    async handleConfirmSumOrder() {
      const params = {
        sumitem: this.gridOptions2.data,
        mplist: this.gridOptions.data
      }
      await this.$confirm('是否确认汇总！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      const res = await apiMaterialPlanSumSave(params)
      if (res.MSGTYPE === 'S') {
        this.$message.success(res.MESSAGE)

        this.queryData(1)
        this.gridOptions2.data = []
        this.already = []
      } else {
        this.$message.warning(res.MESSAGE)
      }
    },
    handleTablePaginationChange1(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    handleTablePaginationChange2(pages) {
      Object.assign(this.pagination2, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
.leftSpacing{
  margin-left: 30px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/materialSumOrder.vue